import Header from "../components/Header";
import {HashRouter, Route, Switch} from "react-router-dom";
import {Container} from "react-bootstrap";
import Constant from "../Constant";
import Distributors from "./Distributors";
import Users from "./Users";
import DistributorDetails from "./DistributorDetails";
import LicenceGeneration from "./LicenceGeneration";
import UserInfo from "./UserInfo";
import FeatureForm from "./FeatureForm";
import FeatureGroupForm from "./FeatureGroupForm";
import PermissionRequired from "../PermissionRequired";
import LicenceSearch from "./LicenceSearch";
import {Permission} from "../Enums";
import LicenceOfDistributor from "./LicenceOfDistributor";
import BatchDetails from "./BatchDetails";
import EditLicence from "./EditLicence";
import Features from "./Features";
import FeatureGroups from "./FeatureGroups";

export default function RouterPage() {
  return (
    <>
      <Header/>
      <Container fluid={true}>
        <div className={"bottomContainer"}>
        <HashRouter>
          <Switch>
            <Route path={Constant.url.DISTRIBUTORS}>
              <PermissionRequired permissions={[Permission.DELIVERY]}>
                <Distributors/>
              </PermissionRequired>
            </Route>
            <Route path={Constant.url.FEATURES}>
              <PermissionRequired permissions={[Permission.DELIVERY]}>
                <Features/>
              </PermissionRequired>
            </Route>
            <Route path={Constant.url.DISTRIBUTOR}>
              <PermissionRequired permissions={[Permission.DELIVERY, Permission.DISTRIBUTOR]}>
                <DistributorDetails/>
              </PermissionRequired>
            </Route>
            <Route path={Constant.url.CREATE_FEATURE}>
              <PermissionRequired permissions={[Permission.DELIVERY, Permission.DISTRIBUTOR]}>
                <FeatureForm/>
              </PermissionRequired>
            </Route>
            <Route path={Constant.url.CREATE_FEATURE_GROUP}>
              <PermissionRequired permissions={[Permission.DELIVERY]}>
                <FeatureGroupForm/>
              </PermissionRequired>
            </Route>
            <Route path={Constant.url.EDIT_FEATURE_GROUP}>
              <PermissionRequired permissions={[Permission.DELIVERY]}>
                <FeatureGroupForm isEdit={true}/>
              </PermissionRequired>
            </Route>
            <Route path={Constant.url.FEATURE_GROUPS}>
              <PermissionRequired permissions={[Permission.DELIVERY]}>
                <FeatureGroups/>
              </PermissionRequired>
            </Route>
            <Route path={Constant.url.LICENCE_GENERATION}>
              <PermissionRequired permissions={[Permission.DELIVERY, Permission.DISTRIBUTOR]}>
                <LicenceGeneration/>
              </PermissionRequired>
            </Route>
            <Route path={Constant.url.EDIT_LICENCE}>
              <PermissionRequired permissions={[Permission.DELIVERY]}>
                <EditLicence/>
              </PermissionRequired>
            </Route>
            <Route path={Constant.url.USERS}>
              <PermissionRequired permissions={[Permission.ADMIN]}>
                <Users/>
              </PermissionRequired>
            </Route>
            <Route path={Constant.url.LICENCES_OF_DISTRIBUTOR}>
              <PermissionRequired permissions={[Permission.DELIVERY, Permission.DISTRIBUTOR]}>
                <LicenceOfDistributor/>
              </PermissionRequired>
            </Route>
            <Route path={Constant.url.LICENCES}>
              <PermissionRequired permissions={[Permission.DELIVERY, Permission.SUPPORT, Permission.DISTRIBUTOR]}>
                <LicenceSearch/>
              </PermissionRequired>
            </Route>
            <Route path={Constant.url.USER_INFO}>
              <UserInfo/>
            </Route>
            <Route path={Constant.url.BATCH}>
              <PermissionRequired permissions={[Permission.DELIVERY, Permission.DISTRIBUTOR]}>
                <BatchDetails/>
              </PermissionRequired>
            </Route>
            {/*<Route path={Constant.url.NO_PERMISSION}>*/}
            {/*  <NoPermission/>*/}
            {/*</Route>*/}
            <Route path={"/"}>
              <UserInfo/>
            </Route>
          </Switch>
        </HashRouter>
        </div>
      </Container>
    </>
  );
}
